import { render, staticRenderFns } from "./tg6.vue?vue&type=template&id=f5097bb2&scoped=true&"
import script from "./tg6.vue?vue&type=script&lang=js&"
export * from "./tg6.vue?vue&type=script&lang=js&"
import style0 from "./tg6.vue?vue&type=style&index=0&id=f5097bb2&prod&lang=scss&scoped=true&"
import style1 from "./tg6.vue?vue&type=style&index=1&id=f5097bb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5097bb2",
  null
  
)

export default component.exports